var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8726 0.00830078C7.27508 0.00830078 7.74945 3.30303 7.74945 3.30303L7.75789 6.71646H15.008V7.74127H4.87824C4.87824 7.74127 0.0166016 7.1899 0.0166016 14.8557C0.0166016 22.5218 4.25996 22.2499 4.25996 22.2499H6.79238V18.6926C6.79238 18.6926 6.65586 14.4492 10.968 14.4492H18.1589C18.1589 14.4492 22.1989 14.5145 22.1989 10.5446V3.98072C22.1989 3.98072 22.8125 0.00830078 14.8726 0.00830078ZM10.8748 2.30377C11.0462 2.30361 11.2158 2.33725 11.3742 2.40274C11.5325 2.46823 11.6763 2.5643 11.7975 2.68544C11.9186 2.80659 12.0147 2.95044 12.0802 3.10875C12.1457 3.26706 12.1793 3.43674 12.1791 3.60807C12.1793 3.77939 12.1457 3.94907 12.0802 4.10738C12.0147 4.2657 11.9186 4.40954 11.7975 4.53069C11.6763 4.65183 11.5325 4.7479 11.3742 4.81339C11.2158 4.87888 11.0462 4.91252 10.8748 4.91236C10.7035 4.91252 10.5338 4.87888 10.3755 4.81339C10.2172 4.7479 10.0734 4.65183 9.95222 4.53069C9.83108 4.40954 9.73501 4.2657 9.66952 4.10738C9.60402 3.94907 9.57039 3.77939 9.57055 3.60807C9.57039 3.43674 9.60402 3.26706 9.66952 3.10875C9.73501 2.95044 9.83108 2.80659 9.95222 2.68544C10.0734 2.5643 10.2172 2.46823 10.3755 2.40274C10.5338 2.33725 10.7035 2.30361 10.8748 2.30377Z",
    fill: "url(#paint0_linear_103_373)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0884 29.7804C22.6859 29.7804 22.2115 26.4857 22.2115 26.4857L22.2031 23.0723H14.9528V22.0475H25.0826C25.0826 22.0475 29.9443 22.5989 29.9443 14.9329C29.9443 7.26692 25.7009 7.53879 25.7009 7.53879H23.1685V11.096C23.1685 11.096 23.305 15.3394 18.9929 15.3394H11.802C11.802 15.3394 7.76197 15.2741 7.76197 19.2441V25.8081C7.76197 25.8081 7.14849 29.7804 15.0883 29.7804H15.0884ZM19.0861 27.4852C18.9148 27.4853 18.7451 27.4517 18.5868 27.3862C18.4285 27.3207 18.2847 27.2246 18.1635 27.1035C18.0424 26.9823 17.9463 26.8385 17.8808 26.6802C17.8153 26.5219 17.7817 26.3522 17.7818 26.1809C17.7817 26.0095 17.8153 25.8398 17.8808 25.6815C17.9463 25.5232 18.0423 25.3793 18.1635 25.2582C18.2846 25.137 18.4285 25.0409 18.5868 24.9754C18.7451 24.9099 18.9148 24.8763 19.0861 24.8764C19.2575 24.8763 19.4271 24.9099 19.5855 24.9754C19.7438 25.0409 19.8876 25.137 20.0088 25.2581C20.1299 25.3793 20.226 25.5231 20.2915 25.6814C20.357 25.8397 20.3906 26.0094 20.3904 26.1807C20.3906 26.3521 20.357 26.5217 20.2915 26.6801C20.226 26.8384 20.1299 26.9822 20.0088 27.1034C19.8876 27.2245 19.7438 27.3206 19.5855 27.3861C19.4271 27.4516 19.2575 27.4852 19.0861 27.485V27.4852Z",
    fill: "url(#paint1_linear_103_373)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_373",
    x1: 2.89263,
    y1: 2.68611,
    x2: 17.7238,
    y2: 17.3693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_373",
    x1: 11.9961,
    y1: 12.1149,
    x2: 27.9231,
    y2: 27.1712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 29.8828,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.4e0984cea4e6bb9fc8d12c5f8d72c6be.svg";
export { ForwardRef as ReactComponent };